import { type RefObject, createContext, createRef } from "react";
import type { IBrandGroup } from "helpers/transforms/entities";

export interface IGlobalContext {
  /**
   * @deprecated use useBrandGroup
   */
  activeBrand: IBrandGroup;
  headerPortalRef: RefObject<HTMLDivElement>;
  /**
   * @deprecated use useFeatureRouteParams
   */
  vendorLevel: string;
  /**
   * @deprecated use useFeatureRouteParams
   */
  vendorLocation: string;
}

export const headerPortalRef = createRef<HTMLDivElement>();

export const GlobalContext = createContext<IGlobalContext>({
  activeBrand: { brand: "", brandId: "", stores: [] },
  headerPortalRef,
  vendorLevel: "",
  vendorLocation: "",
});
